define('views/app/payment',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // models & collections
    'collections/payment/team-payments',
    'collections/payment/membership-plans',
    // views
    'views/modules/setting/business/modals/payment-expired-group-modal',
    'views/modules/setting/business/modals/payment-finish-process-modal',
    'views/modules/setting/business/modals/payment-add-method-modal',
    // templates
    'text!templates/app/payment/payment.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // models & collections
    CTeamPayments,
    CMembershipPlans,
    // views
    VPaymentExpiredGroupModal,
    VPaymentFinishProcessModal,
    VPaymentAddMethodModal,
    // templates
    TLayoutPayment
) {

    var VPaymentLayout = Backbone.View.extend({
        template: TLayoutPayment,
        id: "payment-layout",

        regions: {
            modal: "#payment-modal",
        },

        initialize: function(opt) {
            this.options = _.extend(opt, this.options);
            this.switchModal(opt, false);
        },

        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            if (this.view && this.view.modal) {
                this.generateZones()
                    .assign(this.view.modal, this.zone.$modal);
            }

            return this;
        },

        setModalView: function(modalView) {
            this.view = {
                modal: modalView,
            };
        },

        switchModal: function(options, isRenderNeeded) {
            var modalView = null;
            var teamPaymentsCollection = this.teamPaymentsCollection;

            if (options.view === "finishProcess") {
                this.setModalView(new VPaymentFinishProcessModal(options));
                if (isRenderNeeded) {
                    this.render();
                }
            } else if (options.view === "modifyMethod") {
                if (User.isFetchDue()) {
                    User.fetch({
                        context: this,
                        success: this.showPaymentAddMethodModal
                    });
                }

                if (!this.teamPaymentsCollection) {
                    teamPaymentsCollection = this.teamPaymentsCollection = new CTeamPayments();
                    teamPaymentsCollection.fetch({
                        context: this,
                        success: this.showPaymentAddMethodModal
                    });
                }

                var membershipPlansCollection = this.membershipPlansCollection = new CMembershipPlans();
                membershipPlansCollection.fetch({
                    context: this,
                    success: this.showPaymentAddMethodModal
                });

            } else {
                if (!this.teamPaymentsCollection) {
                    teamPaymentsCollection = this.teamPaymentsCollection = new CTeamPayments();
                    teamPaymentsCollection.fetch({
                        context: this,
                        success: this.showExpiredGroupModal
                    });
                } else {
                    this.showExpiredGroupModal();
                }
            }
        },

        showExpiredGroupModal: function() {
            if (this.teamPaymentsCollection.length !== 0) {
                var teamPaymentModel = this.teamPaymentsCollection.findWhere({ group_id: this.getFirstExpiredGroupId() });

                if (teamPaymentModel.getMembershipPlan() === undefined || teamPaymentModel.getMembershipPlan() === "") {
                    this.setModalView(new VPaymentExpiredGroupModal({
                        useClassicSite: true,
                        teamPaymentModel: teamPaymentModel,
                        isOwner: true
                     }));
                } else {
                    this.setModalView(new VPaymentExpiredGroupModal({
                        useClassicSite: false,
                        teamPaymentModel: teamPaymentModel,
                        isOwner: true
                    }));
                }

                this.render();
            } else {
                this.setModalView(new VPaymentExpiredGroupModal({
                    userClassicSite: false,
                    isOwner: false
                 }));
                this.render();
            }
        },

        showPaymentAddMethodModal: function() {
            if (this.teamPaymentsCollection.length !== 0 && this.membershipPlansCollection.length !== 0 && User !== undefined) {
                var teamPaymentModel;
                if (this.options.force) //Came from old web site try/register.
                    teamPaymentModel = this.teamPaymentsCollection.findWhere({ group_id: User.get('_mainGroupId') });
                else
                    teamPaymentModel = this.teamPaymentsCollection.findWhere({ group_id: this.getFirstExpiredGroupId() });

                var currentPlanModel = this.membershipPlansCollection.findWhere({ name: teamPaymentModel.getMembershipPlan() });

                this.setModalView(new VPaymentAddMethodModal({
                    profile: User,
                    currentPlanModel: currentPlanModel,
                    teamPaymentModel: teamPaymentModel,
                    standalone: true,
                }));

                this.render();
            }
        },

        getFirstExpiredGroupId: function() {
            var groups = User.getAllGroup();

            if (groups) {
                for (var i = 0; i < groups.length; ++i) {
                    if (groups[i].isActive === false) {
                        return groups[i]._id;
                    }
                }
            }

            return null;
        }

    });

    return VPaymentLayout;
});

